import React from 'react';


export const ContainerPageContent = (props) => {
   return (
      <div className='px-md-3 pt-lg-2'>
         {props.children}
      </div>
   );
};

// Adds the default page content container styles
const withPageContentContainerStyle = (Component) => {
   const InnerWithPageContainerStyle = (props) => {
      return (
         <ContainerPageContent>
            <Component {...props}/>
         </ContainerPageContent>
      );
   };

   return InnerWithPageContainerStyle;
};


export default withPageContentContainerStyle;
